import { Component, OnInit, HostListener } from '@angular/core';
import { Router ,ActivatedRoute } from '@angular/router';
import { isUndefined } from 'util';
import { MatDialog } from "@angular/material";

import { RestApiService } from "../shared/restApiServices/restapi.service";
import { VerifyMailIdmodalComponent } from "../verify-mail-idmodal/verify-mail-idmodal.component";

@Component({
  selector: 'app-log-in-billing',
  templateUrl: './log-in-billing.component.html',
  styleUrls: ['./log-in-billing.component.css']
})
export class LogInBillingComponent implements OnInit {

  notSupportedSize : boolean;
  userName = '';
  password = '';
  successMsg = '';
  loginFailMsg:string = '';
  isShowLoader = false;

  nameEmpty:string = '';
  passwordEmpty: string ='';

  constructor(private restApiService: RestApiService, private router: Router , private route: ActivatedRoute, private dialog:MatDialog ) {
    if (window.screen.width < 900) {
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
    if( this.route.queryParams['_value']['email'])
    {
      this.userName = this.route.queryParams['_value']['email'];
      this.successMsg = 'Account was successfully confirmed.';
    }

  }

  ngOnInit() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  logInRequest() {
    this.nameEmpty = '';
    this.passwordEmpty = '';
    this.loginFailMsg = '';

    if (this.userName == null || isUndefined(this.userName) || this.userName == "" || !this.validateEmail(this.userName)) {
      this.nameEmpty = "on-error";
      return;
    }
    else if (this.password == null || isUndefined(this.password) || this.password == "") {
      this.passwordEmpty = "on-error";
      return;
    }
    else {
      this.isShowLoader = true;
      this.restApiService.loginRequestService(this.userName, this.password).subscribe(
        result => {
          let loginResult = result.loginResult;
          if (loginResult.success) {
            let storageData = {
              accessToken: loginResult.tokens.accessToken,
              refreshToken: loginResult.tokens.refreshToken,
              idToken:loginResult.tokens.idToken,
              exp: loginResult.exp
            };
            localStorage.setItem('browserStorage', JSON.stringify(storageData));
            this.isShowLoader = false;
            this.getOrgName();
            this.router.navigateByUrl('/questionnaires');
          }
          else {
            //login failed
            this.isShowLoader = false;
            if(loginResult.verifymail)
            {
              //user mail id is not verified
              this.dialog.open(VerifyMailIdmodalComponent,{
                  width: '46%',
                  data:{
                    name: loginResult['name'],
                    email: this.userName,
                    token: loginResult['accessToken']
                  }
              })
            }
            else{
              this.loginFailMsg = loginResult.value.message;
            }
          }
        })
    }
  }

  getOrgName(){
    this.restApiService.getPlanAndAccountDetailsOfUser().subscribe(res=>{
      if(res && res.success == true){
        let companyName = res.data && res.data.length>0?res.data[0].company_name:'---';
        localStorage.setItem('companyName',companyName);
        this.restApiService.orgName.next(companyName);
      }
    });
  }

  signUpUser(){
    this.router.navigateByUrl('/signUp')
  }

  forgotPassword(){
    this.router.navigateByUrl('/codeforgotPass');
  }
  
  toHome(){
    this.router.navigateByUrl('/home');
  }
  
}



// WEBPACK FOOTER //
// ./src/app/log-in-billing/log-in-billing.component.ts